//jshint esversion:6
import React from "react";
import ReactDOM from "react-dom";
import GomokuGame from "./components/GomokuGame";

ReactDOM.render(<GomokuGame />, document.getElementById("root"));
